import { useEffect, useMemo, FC } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { useNavigate } from 'react-router-dom';

import { SpheraDashboardCard } from '@sphera-cloud/component-ui-reactjs';
import Tile from '../Tile';
import { fetchJobsMetrics, metricsSelector } from 'src/store/slices/metrics';
import { JOBS_RELOAD_TIME } from 'src/utilities/constants';

const Tiles: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const jobsStatistic = useAppSelector(metricsSelector);

  useEffect(() => {
    dispatch(fetchJobsMetrics({}));

    const interval = setInterval(() => {
      dispatch(fetchJobsMetrics({isRefresh: true}));
    }, JOBS_RELOAD_TIME);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const tilesList = useMemo(
    () => [
      {
        name: 'Successful Jobs',
        dividerColor: 'sphera-green',
        icon: 'icon-outline-confirmation-sm',
        count: jobsStatistic.succeeded,
        link: '/jobs',
      },
      {
        name: 'Running',
        dividerColor: 'sphera-blue',
        count: jobsStatistic.running,
        icon: 'icon-outline-assessments',
        link: '/jobs#tab-1',
      },
      {
        name: 'Pending',
        dividerColor: 'sphera-yellow',
        icon: 'icon-outline-question-mark',
        count: jobsStatistic.notStarted,
        link: '/jobs#tab-2',
      },
      {
        name: 'Failed',
        dividerColor: 'sphera-red',
        icon: 'icon-outline-warning',
        count: jobsStatistic.failed,
        link: '/jobs#tab-3',
      },
    ],
    [jobsStatistic],
  );

  const navigateToPage = (link: string) => {
    navigate(link);
  };

  return (
    <div className="tiles">
      <SpheraDashboardCard
        titleHeader="Jobs"
        iconHeader="icon-outline-admin-console"
        width="100%"
        heightCardBody="auto"
      >
        <div className="d-flex">
          {tilesList.map(({ name, count, dividerColor, icon, link }) => (
            <Tile
              key={name}
              name={name}
              icon={icon || 'icon-outline-actions'}
              count={count}
              dividerColor={dividerColor}
              onClick={() => navigateToPage(link)}
            ></Tile>
          ))}
        </div>
      </SpheraDashboardCard>
    </div>
  );
};

export default Tiles;
